// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"38a67da7","455":"ad4aa6b3"}[chunkId] + ".chunk.js";
};